'use client';

import { MainContainer } from './MainContainer';
import type { CampaignConfig, IndexConfig } from '../modules/config.interface';
// import { useCorporateStore } from '@/infrastructure/zustand/corporateStoreProvider';
import type { ReactNode } from 'react';
import Script from 'next/script';

export const Layout = ({
	children,
	config,
	status,
}: {
	children: ReactNode;
	config: IndexConfig | CampaignConfig;
	status: string;
}) => {
	// TODO: or we migrate al analyticsCode from config.tsx to metadata on corporates database or we use the config.tsx alone, not both
	// const analyticsCode = useCorporateStore((state) => state.metadata.analyticsCode ?? config.analyticsCode);
	const corporateTexts = config.metadata.textsCollection.texts;

	return (
		<>
			{config.analyticsCode && (
				<>
					<Script async src={`https://www.googletagmanager.com/gtag/js?id=${config.analyticsCode}`} />
					<Script
						dangerouslySetInnerHTML={{
							__html: `
									window.dataLayer = window.dataLayer || [];
									function gtag(){dataLayer.push(arguments);}
									gtag('js', new Date());

									gtag('config', '${config.analyticsCode}');
								`,
						}}
					/>
				</>
			)}

			<MainContainer config={config}>{children}</MainContainer>
		</>
	);
};
